import { Popup } from "components/common/Popup/Popup";
import { Content } from "./Content/Content";
import { Options } from "./Options/Options";
import { useBottomMenu } from "./useBottomMenu";

export const BottomMenu = () => {
    const { isPopupOpen, openPopup, closePopup, activeType } = useBottomMenu();

    return (
        <div className="py-4 px-2 sm:px-4 dark:border-t dark:border-t-darkSurface-600">
            <Popup
                isOpen={isPopupOpen}
                close={closePopup}
                content={<Content activeType={activeType} closePopup={closePopup} />}
            >
                <Options openPopup={openPopup} />
            </Popup>
        </div>
    );
};
